import { useEffect, useEffectEvent } from 'react';

import { atom, useSetAtom } from 'jotai';
import { useFlags } from 'launchdarkly-react-client-sdk';

export const userInAISearchPOCAtom = atom(false);

export const useUserInAISearchPOCSetter = () => {
  const setUserInAISearchPOC = useSetAtom(userInAISearchPOCAtom);
  const { aiSearchPoc } = useFlags();

  const setUserInAISearchPOCAtom = useEffectEvent((value: boolean) => {
    setUserInAISearchPOC(value);
  });

  useEffect(() => {
    setUserInAISearchPOCAtom(aiSearchPoc && !window.native.isNative);
  }, [aiSearchPoc]);
};
